<template>
  <main class="pt-5">
    <b-row>
      <router-link
        to="/tracking/monitoring"
      >
        <dx-button
          icon="ace-icon icon-back"
          :text="$t('Back')"
          type="normal"
          styling-mode="text"
          class="back-button mb-3"
        />
      </router-link>
    </b-row>
    <h1 class="mb-4 container-number">
      {{ $t('Container') }} {{ container.container }}
    </h1>
    <b-row>
      <b-col>
        <ul
          class="container__blocks"
        >
          <li
            v-for="(item, index) in containerInfoBlocks"
            :key="item.unit_type"
            class="container__item"
          >
            <div
              class="container__icon"
            >
              <div
                class="container__icon-line container__icon-line-top"
                :class="{'container__icon-line_hide': index === 0, 'set-opacity': !item.is_active}"
              />
              <img
                :src="require('../icons/'+iconsTypes[item.unit_type].url)"
                class="container__icon-img"
                :class="item.is_active ? '' : 'set-opacity'"
                width="32px"
              >
              <div
                class="container__icon-line container__icon-line-bottom"
                :class="{'container__icon-line_hide':index === containerInfoBlocks.length - 1,'set-opacity': setHalfOpacity(index) }"
              />
            </div>
            <div
              class="container__block"
              :class="item.is_active ? 'border-blue' : 'border-gray'"
            >
              <div class="col1">
                <div class="col1__start-location">
                  <p class="block__data">
                    {{ item.start_location }}
                  </p>
                  <span
                    v-if="item.start_date"
                    class="block__date"
                  >
                    {{ getDate(item.start_date) }} {{ getHours(item.start_date) }}
                  </span>
                </div>
                <div
                  v-if="showEndLocation(item.unit_type)"
                  class="col1__end-location"
                >
                  <div class="end-location__img" />
                  <div>
                    <p
                      class="block__data"
                    >
                      {{ item.end_location }}
                    </p>
                    <span
                      v-if="item.end_date"
                      class="block__date"
                    >
                      {{ getDate(item.end_date) }} {{ getHours(item.end_date) }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col2"
                :class="{'col2_big-width': setBigWitdhForCol2(item)}"
              >
                <template v-if="showNoCurrentLocation(item.unit_type)">
                  <p class="block__header">
                    {{ headers[item.unit_type].col2 }}
                  </p>
                  <p>{{ item.status_desc }}</p>
                  <p
                    v-if="item.status_date"
                    class="block__date"
                  >
                    {{ getDate(item.status_date) }} {{ getHours(item.status_date) }}
                  </p>
                </template>
                <template v-else-if="showCurrentLocation(item.unit_type)">
                  <p class="block__header">
                    {{ headers[item.unit_type].col2 }}
                  </p>
                  <p class="block__data">
                    {{ item.current_location }}
                  </p>
                  <p class="block__data">
                    {{ item.status_desc }}
                  </p>
                  <p
                    v-if="item.status_date"
                    class="block__date"
                  >
                    {{ getDate(item.status_date) }} {{ getHours(item.status_date) }}
                  </p>
                </template>
              </div>
              <div
                class="col3"
              >
                <template v-if="showTransport(item.unit_type)">
                  <p class="block__header">
                    {{ headers[item.unit_type].col3 }}
                  </p>
                  <p class="block__data">
                    {{ item.transport }}
                  </p>
                </template>
                <template v-else-if="showTdNumber(item.unit_type)">
                  <p class="block__header">
                    {{ headers[item.unit_type].col3 }}
                  </p>
                  <p class="block__data">
                    {{ item.td_number }}
                  </p>
                </template>
              </div>
              <div
                class="col4"
              >
                <template v-if="showCurrentLocation(item.unit_type)">
                  <p class="block__header">
                    {{ headers[item.unit_type].col4 }}
                  </p>
                  <p class="block__data">
                    {{ item.days_left ? item.days_left : "-" }}
                  </p>
                </template>
                <template v-else-if="showDocument(item.unit_type)">
                  <p class="block__header">
                    {{ headers[item.unit_type].col4 }}
                  </p>
                  <p class="block__data">
                    {{ item.document ? item.document : "-" }}
                  </p>
                </template>
                <template v-else-if="showPiNumber(item.unit_type)">
                  <p class="block__header">
                    {{ headers[item.unit_type].col4 }}
                  </p>
                  <p class="block__data">
                    {{ item.pi_number ? item.pi_number : "-" }}
                  </p>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </b-col>
    </b-row>

    <div>
      <dx-data-grid
        ref="historyGrid"
        toolbar.visible="true"
        :data-source="dataSource"
        :remote-operations="remoteOperations"
        :show-borders="false"
        :column-min-width="65"
        :column-auto-width="true"
        :allow-column-resizing="true"
        column-resizing-mode="widget"
        :hover-state-enabled="true"
        class="mb-5"
        @editor-preparing="onEditorPreparing"
        @toolbar-preparing="onToolbarPreparing"
      >
        <dx-column
          header-cell-template="icon-header"
          cell-template="locationTemplate"
        />

        <template #icon-header>
          <img :src="require('../icons/icon-customs.svg')">
        </template>

        <template #locationTemplate="{ data }">
          <img
            v-if="data.data.status.operation_type"
            :src="require('../icons/'+ iconsTypes[((data.data.status.operation_type || {}).code || 'def').toLowerCase()].url)"
            alt="logo"
          >
        </template>


        <dx-column
          data-field="date"
          :caption="$t('Date')"
          data-type="date"
          sort-order="desc"
        />

        <dx-column
          data-field="location.name"
          :caption="$t('Location')"
        />
        <dx-column
          data-field="station_code"
          :caption="$t('Station code')"
        />

        <dx-column
          data-field="status_desc"
          :caption="$t('Status')"
        />

        <dx-column
          data-field="document"
          :caption="$t('Document')"
          width="auto"
        />

        <dx-column
          data-field="transport"
          :caption="$t('Transport')"
        />


        <dx-group-panel :visible="true" />
        <dx-header-filter :visible="true" />
        <dx-search-panel
          :visible="true"
          :highlight-case-sensitive="false"
        />
        <dx-export
          :enabled="true"
          :allow-export-selected-data="true"
          file-name="history"
        />
        <dx-column-chooser :enabled="true" />
        <dx-paging :page-size="10" />
        <dx-pager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          :show-page-size-selector="true"
          :show-info="false"
          :show-navigation-buttons="true"
        />
      </dx-data-grid>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import { locale as localize, loadMessages } from 'devextreme/localization';
import ruMessages from 'devextreme/localization/messages/ru.json';
import {
  DxColumn, DxColumnChooser,
  DxDataGrid,
  DxExport,
  DxGroupPanel,
  DxHeaderFilter, DxPager, DxPaging,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue';
import createSimpleCustomStore from '@/utils/create-simple-custom-store';

export default {
  name: 'Container',
  components: {
    DxDataGrid,
    DxColumn,
    DxGroupPanel,
    DxSearchPanel,
    DxHeaderFilter,
    DxExport,
    DxColumnChooser,
    DxPaging,
    DxPager,
    DxButton,
  },
  props: {
    id: String,
  },
  data: vm => ({
    baseURL: process.env.VUE_APP_API_URL,
    container: {},
    containerInfoBlocks: [],
    pageSizes: [10, 15, 20, 50],
    remoteOperations: {
      sorting: false,
      filtering: false,
      paging: false,
    },
    headers: {
      incoming_railway: {
        col2: 'Статус',
        col3: 'Поезд/Вагон',
        col4: 'Номер документа',
      },
      incoming_sea: {
        col2: 'Статус',
        col3: 'Судно',
        col4: 'Номер документа',
      },
      port_fwd: {
        col2: 'Статус',
        col3: '',
        col4: '',
      },
      customs_decl: {
        col2: 'Статус',
        col3: 'Номер ТД',
        col4: 'Номер ПИ',
      },
      customs_decl_in_route: {
        col2: 'Статус',
        col3: 'Номер ТД',
        col4: 'Номер ПИ',
      },
      railway: {
        col2: 'Статус',
        col3: 'Номер вагона',
        col4: 'Остаток пути(дн)',
      },
      car: {
        col2: 'Статус',
        col3: 'Номер машины',
        col4: 'Остаток пути(дн)',
      },
      finish: {
        col2: 'Статус',
        col3: '',
        col4: '',
      },
    },
    iconsTypes: {
      incoming_railway: {
        url: 'icon-train.svg',
      },
      incoming_sea: {
        url: 'icon-ship.svg',
      },
      customs_decl: {
        url: 'icon-customs.svg',
      },
      customs_decl_in_route: {
        url: 'icon-customs.svg',
      },
      railway: {
        url: 'icon-train.svg',
      },
      car: {
        url: 'icon-car.svg',
      },
      finish: {
        url: 'icon-storage.svg',
      },
      trnst_decl: {
        url: 'icon-customs.svg',
      },
      port_fwd: {
        url: 'icon-port.svg',
      },
    },
    dataSource: createSimpleCustomStore(`container_tracking/api/container/${vm.id}/history/`),
  }),
  computed: {
    ...mapState(['user']),

  },
  async created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
    this.getContainer();
    this.containerInfo();
  },
  methods: {
    setBigWitdhForCol2(item) {
      if (item && item.status_desc) {
        return item.status_desc.length > 74;
      }
      return false;
    },
    setHalfOpacity(index) {
      return (this.containerInfoBlocks.length && index !== (this.containerInfoBlocks.length - 1)) ? !this.containerInfoBlocks[index + 1].is_active : false;
    },
    getDate(date) {
      return date ? date.split('T')[0].split('-').reverse().join('.') + ',' : '';
    },
    getHours(date) {
      if (date.split('').length >= 25) {
        return date.split('T')[1].slice(0, 5) + '+' + date.split('T')[1].slice(-5);
      }
      return date.split('T')[1].slice(0, 5);
    },
    showNoCurrentLocation(type) {
      const arrTypes = ['incoming_sea', 'incoming_railway', 'customs_decl', 'port_fwd', 'customs_decl_in_route', 'finish'];
      return arrTypes.includes(type);
    },
    showCurrentLocation(type) {
      const arrTypes = ['railway', 'car'];
      return arrTypes.includes(type);
    },
    showEndLocation(type) {
      const arrTypes = ['incoming_sea', 'incoming_railway', 'railway', 'car'];
      return arrTypes.includes(type);
    },
    showTransport(type) {
      const arrTypes = ['incoming_sea', 'incoming_railway', 'railway', 'car'];
      return arrTypes.includes(type);
    },
    showTdNumber(type) {
      const arrTypes = ['customs_decl', 'customs_decl_in_route'];
      return arrTypes.includes(type);
    },
    showDocument(type) {
      const arrTypes = ['incoming_sea', 'incoming_railway'];
      return arrTypes.includes(type);
    },
    showPiNumber(type) {
      const arrTypes = ['customs_decl', 'customs_decl_in_route'];
      return arrTypes.includes(type);
    },
    async getContainer() {
      this.container = await this.$http.get(`container_tracking/api/container/${this.id}/`);
    },
    async containerInfo() {
      const results = await this.$http.get(`/container_tracking/api/container/${this.id}/steps/`);
      this.containerInfoBlocks = results;
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-refresh',
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    // onToolbarPreparing(e) {
    //   e.toolbarOptions.items.push({
    //     location: 'before',
    //     widget: 'dxButton',
    //     options: {
    //       icon: 'ace-icon icon-refresh',
    //       onClick: this.refreshDataGrid.bind(this),
    //     },
    //   }, {
    //     location: 'after',
    //     widget: 'dxButton',
    //     options: {
    //       icon: 'ace-icon icon-close',
    //       hint: this.$t('clear_filters'),
    //       onClick: this.clearFilter.bind(this),
    //     },
    //   }, {
    //     location: 'after',
    //     widget: 'dxButton',
    //     options: {
    //       icon: 'ace-icon icon-bind',
    //       text: this.$t('Create package'),
    //       type: 'success',
    //       height: 48,
    //       onClick: this.showPackageContent.bind(this),
    //     },
    //   });
    //   e.toolbarOptions.items.forEach((item) => {
    //     if (item.name === 'searchPanel') {
    //       item.location = 'before';
    //       item.stylingMode = 'outlined';
    //     }
    //   });
    // },
    onEditorPreparing(e) {
      if (e.parentType === 'searchPanel') {
        e.editorOptions.stylingMode = 'outlined';
        e.editorOptions.width = '300px';
      }
    },
    refreshDataGrid() {
      this.$refs.historyGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.historyGrid.instance.clearFilter();
    },
    TD_PDF_URL() {
      return `${this.baseURL}/container_tracking/api/container/${this.container.id}/td/`;
    },
    getTdFileName(type) {
      return this.container.td_number.split('/').join('_') + '.' + type;
    },
    openFile(url, filename) {
      this.$http({
        url,
        method: 'GET',
        responseType: 'blob',
      }).then(response => {
        const href = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', filename);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

  },
};
</script>

<style lang="scss" scoped>

 .container__blocks {
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  padding-left: 0;
  margin-bottom: 120px;
  list-style: none;
}


.container__item {
  display: flex;
  flex-direction: row;
  column-gap: 2rem;
}

.container__icon {
  display: flex;
  position: relative;
  align-items: center;
  position: relative;
}


.container__block {
  display: flex;
  flex-direction: row;
  column-gap: 3rem;
  width: 100%;
  padding: 24px;
  border: 2px solid;
  border-radius: 8px;
  @media(max-width: 1930px) {
    column-gap: 1.5rem;
  }
  @media(max-width: 1400px) {
    column-gap: 1.3rem;
  }
  @media(max-width: 1250px) {
    row-gap: 1.2rem;
  }
  @media(max-width: 992px) {
    column-gap: 0.5rem;
  }
}

.col1 {
  display: flex;
  flex-direction: row;
  @media(max-width: 1930px) {
    width: 20rem;
  }
  @media(max-width: 1400px) {
    width: 18rem;
  }
  @media(max-width: 1250px) {
    width: 16rem;
  }
  @media(max-width: 992px) {
    width: 15rem;
  }
}

.col2,
.col2,
.col3,
.col4 {
  @media(max-width: 1930px) {
      width: 12rem;
  }
  @media(max-width: 1400px) {
      width: 10rem;
  }
  @media(max-width: 1250px) {
      width: 8rem;
  }
  @media(max-width: 992px) {
      width: 6rem;
  }
}

.col2_big-width {
  width: 15rem;
}

.container__icon-img {
  width: 34px;
}

.col1__start-location {
  margin-right: 1rem;
}

.col1__end-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: fit-content;
}
.end-location__img {
  margin-right: 1rem;
  min-width: 24px;
  height: 24px;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 12H5M5 12L11 6M5 12L11 18' stroke='%233C5AC3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  transform: rotate(180deg);
}

.block__header,
.block__date {
  font-size: 12px;
  font-weight: 400;
}

.block__header {
  margin-bottom: 8px;
}

.block__data {
  margin-bottom: 5px;
  word-wrap: break-word;
}

.border-blue {
  border-color: #3c5ac3;
}

.border-gray {
  border-color: #E0E6EE;
}

.set-opacity{
  opacity: 0.5;
}
.container__icon-line {
  position: absolute;
  width: 2px;
  height: calc(50% - 16px);
  background-color: #3c5ac3;
  left: 50%;
}
.container__icon-line-top {
  top: -0.75rem;
}
.container__icon-line-bottom {
  bottom: -0.75rem;
}
.container__icon-line_hide {
  visibility: hidden;
}

</style>
